module.exports = __webpack_public_path__ + "static/media/4.c3b2d71d.JPG";